import { useEffect, useState } from "react";
import api from "@/lib/api";

// Cache of the admin-defined circuit layout (tiers + unsorted + unverified "other") per sport.
const cache = {}; // sport -> config object

const EMPTY = { tiers: [], unsorted: [], other: [], main: [], all_known: [] };

export function invalidateCircuitConfig(sport) {
    if (sport) delete cache[sport];
    else Object.keys(cache).forEach((k) => delete cache[k]);
}

/** Returns { tiers, unsorted, other, main, all_known } for a sport (loads lazily, cached). */
export function useCircuitConfig(sport) {
    const [cfg, setCfg] = useState(() => cache[sport] || EMPTY);
    useEffect(() => {
        let alive = true;
        if (!sport) return undefined;
        if (cache[sport]) { setCfg(cache[sport]); return undefined; }
        api.get(`/circuits/config?sport=${encodeURIComponent(sport)}`)
            .then((r) => { cache[sport] = r.data; if (alive) setCfg(r.data); })
            .catch(() => { if (alive) setCfg(EMPTY); });
        return () => { alive = false; };
    }, [sport]);
    return cfg;
}
